import React from 'react'
import { LoginWrapper } from '../../Components'

function LandingScreen() {
    return (
        <LoginWrapper />
    )
}

export default LandingScreen